import { Box } from "@mui/material";
import React from "react";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Page from "src/components/Page";
import { PATH_DASHBOARD } from "src/routes/paths";
import DataTable from "./components/dataTable";

const Consultation = () => {
  return (
    <div>
      <Page title={"consultation.consultation"}>
        <Box>
          <HeaderBreadcrumbs
            heading={"consultation.consultation"}
            links={[
              { name: "global.dashboard", href: PATH_DASHBOARD.root },
              {
                name: "consultation.consultation",
              },
            ]}
          />
          <DataTable />
        </Box>
      </Page>
    </div>
  );
};

export default Consultation;
